import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal";
import { useTranslation } from "react-i18next";

const InviteSuccessModal = ({ event, prize, onClose, show }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Log when component renders
  const handleClaimPrize = () => {
    if (!event?.id) {
      return;
    }

    // Navigate to the event page where the spin wheel is
    navigate(`/single-event?eventId=${event.id}`);
    onClose();
  };

  return (
    <Modal show={show} onClose={onClose} title={t("claim_your_prize")} width="500px">
      <p className="mb-4 text-white">
        {t("invite_claim_prize_body")}
      </p>

      <button
        onClick={handleClaimPrize}
        className="p-[10px] !pb-[10px] !border-[2px] border-[#9865db] rounded-[4px] w-full font-semibold text-[16px] text-white premium-button"
      >
        {t("claim_prize")}
      </button>
    </Modal>
  );
};

export default InviteSuccessModal;
